import { render, staticRenderFns } from "./lista.vue?vue&type=template&id=57751776&scoped=true"
import script from "./lista.vue?vue&type=script&lang=js"
export * from "./lista.vue?vue&type=script&lang=js"
import style0 from "./lista.vue?vue&type=style&index=0&id=57751776&prod&scoped=true&lang=css"
import style1 from "./lista.vue?vue&type=style&index=1&id=57751776&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57751776",
  null
  
)

export default component.exports